module.exports = __webpack_public_path__ + "static/img/m-t-logo.b43eb597.png";